import _ from 'lodash';
import ScrollTrigger from 'gsap/ScrollTrigger';
import gsap from 'gsap';

const $postsContainer = $('.js-posts-container');

gsap.registerPlugin(ScrollTrigger);
ScrollTrigger.saveStyles('.js-case-image');

function initPosts($container) {
  const url = $container.data('url');
  const items = $container.data('items-per-page');
  const action = $container.data('action');
  const $moreBtn = $container.find('.js-load-posts');
  const $loader = $container.find('.js-posts-loader');
  const $filterSelect = $container.find('.js-filter');
  const $filterSelect1 = $container.find('.js-filter[data-type="select1"]');
  const $filterSelect2 = $container.find('.js-filter[data-type="select2"]');
  const $postTemplate = $container.find('.js-post-template');
  const $list = $container.find('.js-posts-list');
  const params = {
    select1: '',
    select2: '',
    page: 1,
    action,
    // eslint-disable-next-line camelcase
    posts_per_page: items
  };
  let count = items;
  const compiled = _.template($postTemplate.html());

  $moreBtn.click((e) => {
    e.preventDefault();
    params.page += 1;
    getPosts();
  });

  $filterSelect.change(function(e) {
    if ($(this).data('type') === 'select1') {
      params.select2 = '';
      $filterSelect2.val('').customSelect('reset');
    } else {
      params.select1 = '';
      $filterSelect1.val('').customSelect('reset');
    }
    params.page = 1;
    count = 0;
    $list.html('');
    const type = $(this).data('type');
    params[type] = e.currentTarget.value;
    getPosts();
  });

  const getPosts = () => {
    $.ajax({
      type: 'GET',
      url: url,
      data: params,
      dataType: 'json',
      beforeSend: () => {
        $moreBtn.hide();
        $loader.show();
      }
    })
      .done((response) => {
        count += items;
        $loader.hide();
        $list.append(compiled({'items': response.data}));
        if (response.total > count) {
          $moreBtn.show();
        }
        ScrollTrigger.matchMedia({
          '(min-width: 960px)': () => {
            const tl = gsap.timeline();
            $('.js-case-image').each(function(index, item) {
              ScrollTrigger.update();
              tl.to(item, {
                x: 0, scrollTrigger: {
                  trigger: item,
                  start: 'top bottom',
                  end: 'center top',
                  scrub: true,
                }
              });
            });
            ScrollTrigger.getAll().forEach(instance => {
              instance.refresh();
            });
          }
        });
      });
  };
}

$postsContainer.length && $postsContainer.each(function(index, item) {
  initPosts($(item));
});
